module.exports = ".cover-bg {\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tbackground-size: cover;\n}\n#main{\n\tpadding-top: 80px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.css
// module id = ./src/app/components/app/app.component.css
// module chunks = main